import { createVNode as l, mergeProps as i } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ErrorFilled.js";
import s from "../components/PfIcon.js";
const r = (o, e) => {
  const t = {
    ...o,
    ...e.attrs
  };
  return l(s, i(t, {
    icon: m
  }), null);
};
r.displayName = "ErrorFilled";
r.inheritAttrs = !1;
export {
  r as default
};
